var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.ventureId)?_c('nuxt-link',{attrs:{"to":{
    name: _vm.to,
    params: { venture: _vm.ventureId, metricAssignmentId: _vm.metricAssignmentId },
  }}},[_c('div',{staticClass:"impact-name ml-2"},[_c('company-logo',{attrs:{"name":_vm.name,"logo":_vm.logo,"tooltip-direction":{ right: false, top: true }}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }